module.exports = __webpack_public_path__ + "static/mail_gmail-3e825cee8c7bbd2abc83bf41dbe62e08.png";